module.exports = __webpack_public_path__ + "img/logo-4.9d2350b0.png";